import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 3l4 4l-4 4","key":"svg-0"}],["path",{"d":"M10 7l10 0","key":"svg-1"}],["path",{"d":"M8 13l-4 4l4 4","key":"svg-2"}],["path",{"d":"M4 17l9 0","key":"svg-3"}]]

const IconSwitchHorizontal = createReactComponent('outline', 'switch-horizontal', 'SwitchHorizontal', __iconNode);

export default IconSwitchHorizontal;